import { render, staticRenderFns } from "./AccommodationPriceUpdationAll.vue?vue&type=template&id=b988bbdc&scoped=true&"
import script from "./AccommodationPriceUpdationAll.vue?vue&type=script&lang=js&"
export * from "./AccommodationPriceUpdationAll.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationPriceUpdationAll.vue?vue&type=style&index=0&id=b988bbdc&scoped=true&lang=scss&"
import style1 from "./AccommodationPriceUpdationAll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b988bbdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCheckbox,VCol,VDatePicker,VDialog,VIcon,VMenu,VRadio,VRadioGroup,VRow,VSelect,VTextField})
